"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useOnPressEsc;

var _react = require("react");

function useOnPressEsc(handler) {
  var downHandler = (0, _react.useCallback)(function (_ref) {
    var keyCode = _ref.keyCode;

    if (keyCode === 27) {
      handler && handler();
    }
  }, [handler]);
  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', downHandler);
    return function () {
      window.removeEventListener('keydown', downHandler);
    };
  }, [downHandler]);
}